export function initScrollHint() {
  const tables = document.querySelectorAll('.table-scroll');
  if (!tables.length) return;

  new ScrollHint(tables, {
    i18n: {
      scrollable: 'スクロールできます',
    },
  });
}
